export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
    redirectUri: window.location.origin + "/_callback",
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
    secureCookies: window.location.protocol === "https:",
  },
  system: {
    allowRedirectInIframe: false,
    loggerOptions: {
      logLevel: 3,
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: process.env.REACT_APP_AZURE_SCOPES?.split(/\s+/) || [],
  redirectUri: window.location.origin + "/_callback",
};
